var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Loading',{attrs:{"active":_vm.loading}}),_c('Level',{scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('PageTitle',[_vm._v(_vm._s(_vm.$t('integrations.marketplace')))])]},proxy:true}])}),_c('div',{staticClass:"integrations-home"},[_c('Sidebar'),_c('ListingContents')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }